import { motion } from "framer-motion";
import { IMAGES } from "@/lib/site";

const CASES = [
  {
    client: "FinTech Scaleup Solution",
    category: "Web App Development & Hosting",
    metric: "+210% Conversion Growth",
    image: IMAGES.cases[0],
    desc: "Complete redesign and custom React build paired with isolated NVMe cloud infrastructure.",
  },
  {
    client: "Global Logistics Hub",
    category: "Cloud Hosting Systems & Security",
    metric: "99.999% Uptime Achieved",
    image: IMAGES.cases[1],
    desc: "Zero-downtime migration of multi-regional database clusters and continuous WAF protection.",
  },
  {
    client: "Apex Performance Brand",
    category: "Marketing Campaign & Landing Systems",
    metric: "4.8x Return on Ad Spend",
    image: IMAGES.cases[2],
    desc: "Full marketing funnel engineering with high-velocity landing page personalization.",
  },
];

export const Cases = () => (
  <section id="cases" className="py-20 lg:py-32">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
      <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
                  className="max-w-2xl mb-14">
        <p className="font-semibold text-xs uppercase tracking-[0.2em] text-blue-600 dark:text-blue-400 mb-4">Proof of work</p>
        <h2 className="font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl">Selected Works & Case Studies</h2>
        <p className="mt-4 text-base sm:text-lg text-slate-600 dark:text-slate-300">
          Measurable outcomes across marketing, development, and infrastructure engagements.
        </p>
      </motion.div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {CASES.map((c, i) => (
          <motion.article key={c.client} data-testid={`case-study-card-${i}`}
                          initial={{ opacity: 0, y: 32 }} whileInView={{ opacity: 1, y: 0 }}
                          viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, delay: i * 0.12 }}
                          className="group rounded-3xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 overflow-hidden hover:border-primary/50 hover:shadow-2xl hover:shadow-blue-500/10 transition-all duration-300">
            <div className="relative h-56 overflow-hidden">
              <img src={c.image} alt={c.client} loading="lazy"
                   className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950/70 to-transparent" />
              <span className="absolute bottom-4 left-4 px-3 py-1.5 rounded-full bg-primary text-white text-xs font-bold">
                {c.metric}
              </span>
            </div>
            <div className="p-6 sm:p-8">
              <p className="font-semibold text-xs uppercase tracking-[0.2em] text-blue-600 dark:text-blue-400">{c.category}</p>
              <h3 className="mt-3 font-bold text-lg sm:text-xl tracking-tight">{c.client}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600 dark:text-slate-300">{c.desc}</p>
            </div>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
